import { all, fork } from "redux-saga/effects"

//public
import ForgetSaga from "./auth/forgetpwd/saga"
import AuthSaga from "./auth/login/saga"
import AccountSaga from "./auth/register/saga"
import calendarSaga from "./calendar/saga"
import catalogsCoordinationsSaga from "./catalogs/Coordinations/saga"
import catalogsCustomersSaga from "./catalogs/Customers/saga"
import emaRegulationsSaga from "./catalogs/EmaRegulations/saga"
import internalSamplesSaga from "./catalogs/InternalSamples/saga"
import catalogsKindsSaga from "./catalogs/Kinds/saga"
import catalogsLabAreaSaga from "./catalogs/LabAreas/saga"
import labSagas from "./catalogs/Laboratories/saga"
import catalogsLabSegmentSaga from "./catalogs/LabSegments/saga"
import labTestSaga from "./catalogs/LabTests/saga"
import labTestSamplesSaga from "./catalogs/LabTestSamples/saga"
import catalogsLabTypeSaga from "./catalogs/LabTypes/saga"
import catalogsLocationsSaga from "./catalogs/Locations/saga"
import catalogsMenuSaga from "./catalogs/menu/saga"
import normsSaga from "./catalogs/Norms/saga"
import productsSaga from "./catalogs/Products/saga"
import catalogsProductTypesSaga from "./catalogs/ProductTypes/saga"
import catalogsProvidersSaga from "./catalogs/Providers/saga"
import quotationSagas from "./catalogs/Quotations/saga"
import regionsSaga from "./catalogs/Regions/saga"
import statusSampleSaga from "./catalogs/StatusSamples/saga"
import surveyCategoriesSaga from "./catalogs/SurveyCategories/saga"
import surveyConceptsSaga from "./catalogs/SurveyConcepts/saga"
import technicalAdvisersSaga from "./catalogs/TechnicalAdvisers/saga"
import typesRegulationsSaga from "./catalogs/TypesRegulations/saga"
import catalogsUnitMeasuresSaga from "./catalogs/UnitMeasures/saga"
import usersSaga from "./catalogs/Users/saga"
import serviceTypesSaga from "./catalogs/ServiceTypes/saga"
import defaultAssignmentsSaga from "./catalogs/DefaultAssignments/saga"
import LayoutSaga from "./layout/saga"


// Lab Request Sagas
import labRequestSagas from "./labCitec/labRequest/saga"
import labRequestAssignmentSagas from "./labCitec/labRequestAssignments/saga"
import labRequestCalendarSagas from "./labCitec/labRequestCalendaredRecord/saga"
import labRequestDeliveryResultSagas from "./labCitec/labRequestDeliveryResult/saga"
import labRequestDeliveryResultPartialSagas from "./labCitec/labRequestDeliveryResultPartial/saga"
import labRequestEssaySagas from "./labCitec/labRequestEssay/saga"
import labRequestIncidentsSagas from "./labCitec/labRequestIncidents/saga"
import labRequestQuotesSagas from "./labCitec/labRequestQuotations/saga"
import labRequestReportSagas from "./labCitec/labRequestReport/saga"
import labRequestReportAuxSagas from "./labCitec/labRequestReportAux/saga"
import labRequestReportRoiSagas from "./labCitec/labRequestReportsRoi/saga"
import labRequestReqSagas from "./labCitec/labRequestReq/saga"
import labRequestSampleSagas from "./labCitec/labRequestSamples/saga"
import labRequestSurveySagas from "./labCitec/labRequestSurvey/saga"
import labRequestSurveyResponseSagas from "./labCitec/labRequestSurveyResp/saga"
import labRequestTestSagas from "./labCitec/labRequestTest/saga"
import labRequestTestSampleSagas from "./labCitec/labRequestTestSamples/saga"
import labRequestTrackingsSagas from "./labCitec/labRequestTrackings/saga"

// Notifications Sagas
import notificationManagersSagas from "./notifications/managers/saga"
import notificationResponsiblesSagas from "./notifications/responsibles/saga"

// Norm Library Sagas
import normLibrarySagas from "./normsLibrary/saga"

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ForgetSaga(),
    fork(LayoutSaga),
    fork(calendarSaga),
    fork(catalogsMenuSaga),
    fork(catalogsLabTypeSaga),
    fork(catalogsLabAreaSaga),
    fork(catalogsLabSegmentSaga),
    fork(catalogsCoordinationsSaga),
    fork(catalogsUnitMeasuresSaga),
    fork(serviceTypesSaga),
    fork(defaultAssignmentsSaga),
    fork(catalogsLocationsSaga),
    fork(catalogsKindsSaga),
    fork(catalogsCustomersSaga),
    fork(catalogsProductTypesSaga),
    fork(catalogsProvidersSaga),
    fork(typesRegulationsSaga),
    fork(technicalAdvisersSaga),
    fork(productsSaga),
    fork(regionsSaga),
    fork(normsSaga),
    fork(emaRegulationsSaga),
    fork(internalSamplesSaga),
    fork(labTestSaga),
    fork(labTestSamplesSaga),
    fork(surveyCategoriesSaga),
    fork(surveyConceptsSaga),
    fork(usersSaga),
    fork(statusSampleSaga),
    fork(labRequestSagas),
    fork(labRequestReportSagas),
    fork(labRequestReportAuxSagas),
    fork(labRequestReqSagas),
    fork(labRequestSampleSagas),
    fork(labRequestTestSagas),
    fork(labRequestAssignmentSagas),
    fork(labSagas),
    fork(labRequestTrackingsSagas),
    fork(labRequestIncidentsSagas),
    fork(notificationManagersSagas),
    fork(notificationResponsiblesSagas),
    fork(normLibrarySagas),
    fork(labRequestDeliveryResultSagas),
    fork(labRequestCalendarSagas),
    fork(labRequestEssaySagas),
    fork(labRequestTestSampleSagas),
    fork(labRequestSurveySagas),
    fork(labRequestSurveyResponseSagas),
    fork(labRequestDeliveryResultPartialSagas),
    fork(quotationSagas),
    fork(labRequestQuotesSagas),
    fork(labRequestReportRoiSagas),
  ])
}
